import React from "react";
import { Row, Col, Input, Button, Icon, Divider } from "antd";
import { strings } from "../../../helpers";
import DocImage from "../../../images/doctor.svg";
import DoctorPhotoContainer from "./DoctorPhotoContainer";

export default class DoctorInfoTopView extends React.Component {
  render() {
    const {
      doctorsDetail,
      handleChange,
      showEditFeeInput,
      toggleAddFeeView,
      updateDoctorFees,
      fees,
      updateProcessing,
      setFeeWrapperRef,
      displayPhotos,
      getImageData
    } = this.props;

    return (
      <div className="with-box-shadow white-bg min-ht-block doc-detail-card">
        <div>
          <Row gutter={14} type="flex">
            <Col span={24}>
              <div>
                {/* if status === "JOINED", then do not allow clinic to modify the photo, and show the uploaded doctor photo/ or default photo  */}
                {/* {doctorsDetail.status === "JOINED" && (
                  <Row type="flex">
                    <Col span={24}>
                      <div
                        className="picture-wrapper"
                        style={{
                          backgroundImage:
                            doctorsDetail.doctor.photo &&
                            doctorsDetail.doctor.photo !== ""
                              ? `url(${doctorsDetail.doctor.photo})`
                              : `url(${DocImage})`
                        }}
                      />
                    </Col>
                  </Row>
                )} */}
                {/* if status === "INVITED", then allow clinic to modify the photo, and show the uploaded doctor photo and allow user to edit and delete it  */}
                {/* {doctorsDetail.status === "INVITED" && ( */}
                <Row
                  type="flex"
                  gutter={16}
                  justify="space-between"
                  align="top"
                >
                  <Col
                    lg={5}
                    md={6}
                    sm={6}
                    xs={8}
                    className="centered-text position-rel"
                  >
                    <DoctorPhotoContainer
                      displayPhotos={displayPhotos}
                      doctorObj={doctorsDetail}
                      getImageData={getImageData}
                    />
                  </Col>
                  {/* </Row> */}

                  {/* <Row type="flex" className="centered-text"> */}
                  <Col lg={18} md={15} sm={14} xs={12}>
                    <div>
                      <Row justify="start">
                        <Col span={24}>
                          <h4 className="header-title mb-0">
                            {`${doctorsDetail.doctor.title}`}
                          </h4>
                        </Col>
                        {doctorsDetail.doctor.speciality && (
                          <Col span={24}>
                            <span className="content-info ">
                              {doctorsDetail.doctor.speciality}
                            </span>
                          </Col>
                        )}
                        {doctorsDetail.doctor.education && (
                          <Col span={24}>
                            <span className="content-info ">
                              {doctorsDetail.doctor.education}
                            </span>
                          </Col>
                        )}
                      </Row>
                      <Row>
                        <Col span={24}>
                          <div className="doc-info-content">
                            <Divider />
                            {doctorsDetail.doctor.phone_number && (
                              <span className="content-info">
                                <label className="custom_label">
                                  {"Mobile no"}:
                                </label>

                                <span>{doctorsDetail.doctor.phone_number}</span>
                              </span>
                            )}
                            {doctorsDetail.doctor.gender && (
                              <span className="content-info">
                                <label className="custom_label">
                                  {"Gender"}:
                                </label>
                                <span> {doctorsDetail.doctor.gender}</span>
                              </span>
                            )}

                            {doctorsDetail.fees !== 0 &&
                              doctorsDetail.fees !== null && (
                                <span className="content-info">
                                  <label className="custom_label">
                                    {"In clinic fees"}:
                                  </label>
                                  <span>
                                    &#8377;
                                    {doctorsDetail.fees}
                                  </span>
                                </span>
                              )}

                            {doctorsDetail.telemedicine_fees !== 0 &&
                              doctorsDetail.telemedicine_fees !== null && (
                                <span className="content-info">
                                  <label className="custom_label">
                                    {"Telemedicine fees"}:
                                  </label>
                                  <span>
                                    &#8377;
                                    {doctorsDetail.telemedicine_fees}
                                  </span>
                                </span>
                              )}
                          </div>
                        </Col>
                      </Row>

                      {/* <Row style={{ display: "none" }}>
                        <Col span={24}>
                          <div ref={setFeeWrapperRef}>
                            {!showEditFeeInput && (
                              <span className="content-info relative">
                                {!doctorsDetail.fees ||
                                doctorsDetail.fees === 0 ? (
                                  <React.Fragment>
                                    <Divider />
                                    {strings.doctors.fees}{" "}
                                    {strings.doctors.notAvailable}{" "}
                                    <a
                                      href="javascript:;"
                                      className="edit-fees"
                                      onClick={toggleAddFeeView}
                                    />
                                  </React.Fragment>
                                ) : (
                                  ""
                                )}
                              </span>
                            )}
                            {showEditFeeInput && (
                              <div className="content-info relative">
                                <Input
                                  size="small"
                                  name="fees"
                                  placeholder={strings.doctors.feesPlaceholder}
                                  className="fees-input"
                                  onChange={handleChange}
                                  type="number"
                                  defaultValue={fees}
                                  autoFocus
                                />
                                <span>
                                  <Button
                                    type="primary"
                                    size="small"
                                    onClick={updateDoctorFees}
                                    loading={updateProcessing}
                                  >
                                    <Icon type="check" />
                                  </Button>
                                </span>
                              </div>
                            )}
                          </div>
                        </Col>
                      </Row> */}
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
